import { HeadMeta } from '@/components/Molecules/HeadMeta/HeadMeta';
import { EmptyNavigation } from '@/components/Organisms/Navigation/EmptyNavigation';
import type { FCh } from 'react-fc';
import styled from 'styled-components';

export const ViewArea = styled.div`
    height: calc(100vh - var(--size-masthead-height));
    display: flex;
    > * {
        align-self: center;
    }
`;

export const ErrorPageTemplate: FCh<{ title: string }> = ({ title, children }) => {
    return (
        <>
            <HeadMeta title={title} />
            <EmptyNavigation />
            <ViewArea>{children}</ViewArea>
        </>
    );
};
